import React from 'react';
import { Navigate } from 'react-router-dom';
import { clearStoredToken, getCurrentUser } from '../utils/auth';

export default function ProtectedRoute({ children }) {
  const user = getCurrentUser();
  if (!user) {
    clearStoredToken();
    return <Navigate to="/login" replace />;
  }
  return children;
}
